var map = {
	"./KendraConfig": 33725,
	"./KendraConfig.ts": 33725,
	"./constants": 12291,
	"./constants.ts": 12291,
	"./helpers/LocalCredentialsBanner": 17933,
	"./helpers/LocalCredentialsBanner.tsx": 17933,
	"./helpers/MockDataWarning": 5110,
	"./helpers/MockDataWarning.tsx": 5110
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92661;